export default __webpack_public_path__ + "static/media/vendexpresslogo.747cfdf8.svg";